import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-interbranch-invoicing-mi',
  templateUrl: './interbranch-invoicing-mi.component.html',
  styleUrls: ['./interbranch-invoicing-mi.component.css']
})
export class InterbranchInvoicingMiComponent implements OnInit {
    businessCoNoFrom;

    businessCoNoTo;

    public edit?: Edit;

    public creating = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.businessCoNoFrom = this.stateService.getStateParams()['businessco_no_from'];
        this.businessCoNoTo = this.stateService.getStateParams()['businessco_no_to'];
    }

    private async loadEdit() {
        if (!!this.businessCoNoFrom && !!this.businessCoNoTo) {
            this.edit = (await this.datatask.Post(800, {
                businessco_no_from: this.businessCoNoFrom,
                businessco_no_to: this.businessCoNoTo
            }))[0];
        }
    }

    public async createChanges() {
        if (!!this.edit) {
            try {
                this.creating = true;

                const response = (await this.datatask.Post(802, this.edit))[0];

                this.stateService?.go('invoicehead', { invoice_no: response?.invoice_no });
            } finally {
                this.creating = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    businessco_no_from: string;
    businessco_name_from: string;
    businessco_no_to: string;
    businessco_name_to: string;
    invoice_date: string;
    invoice_valuta_id: string;
    errorinfo: string;
    amount_to_invoice_invval: string;
    show_create_invoice_button: string;
    invoice_cust_no: string;
    deliverydate_tom: string;
}
